<template>
  <input
    :type="editAble ? 'number' : 'text'"
    step="0.01"
    :maxlength="type === 'RISK' ? 12 : undefined"
    ref="focusInput"
    class="form-control bet-slip-form-control mr-2"
    @blur="
      editAble = false;
      vk_hide();
    "
    @focus="
      editAble = true;
      vk_show($event);
      vk_common_show({ target: null, visible: false });
    "
    :class="buildClass()"
    :value="normalizeAmount()"
    @input="onInput($event)"
    :placeholder="$t(type === 'WIN' ? 'Win' : 'Risk') + ' ' + currency + '' + (customPlaceHolder || '')"
    onkeydown="return event.keyCode !== 69"
    :disabled="freeWagersViewing || type === 'WIN'"
    @keypress="isNumber"
  />
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import snq from 'snq';
import { roundAmount } from '@/views/sports/components/bet-slip/bet-slip-utils';
import { modifyAmountInput } from '@/utils/common';

export default {
  props: ['amount', 'type', 'min', 'max', 'riskedAmount', 'customPlaceHolder', 'limitControl', 'isCustomLimitControl'], // type: WIN | RISK
  data() {
    return {
      editAble: false,
    };
  },
  computed: {
    ...mapGetters('player', ['currencySymbol']),
    ...mapState('betSlip', ['validity']),
    ...mapState('freeWagerStore', ['freeWagersViewing']),
    ...mapState({
      activeFreeBet: (state) => state.betSlip.activeFreeBet,
    }),
    ...mapState({
      terminalInfo: (state) => state.settings.terminalInfo,
    }),
    currency() {
      return this.currencySymbol || snq(() => this.terminalInfo.currency_symbol);
    },
  },
  methods: {
    ...mapMutations('helper', ['vk_show', 'vk_hide', 'vk_update_value', 'vk_common_show']),
    modifyAmountInputVK(value, button) {
      const hasDot = snq(() => value.includes('.'));
      if (hasDot && button === '.') {
        return;
      }
      return value;
    },
    onInputChange(input) {
      this.$emit('update:amount', input.target.value);
      this.$emit('change', input.target.value);
    },
    isNumber: function (evt) {
      modifyAmountInput(evt);
    },
    onInput($event) {
      this.isNumber($event);
      let val = $event.target.value;
      if (this.type === 'RISK' && val.length > 12) val = val.slice(0, 12);
      this.$emit('update:amount', val);
      this.$emit('change', val);
      this.$store.commit('helper/vk_update_input_value', val);
    },
    buildClass() {
      return {
        'is-invalid': this.isAmountEmpty() || (this.amountToFloat() !== 0 && this.exceedsLimits()),
        filled: this.amount !== '' && !this.exceedsLimits(),
      };
    },
    amountToFloat() {
      if (this.amount < this.riskedAmount || this.activeFreeBet) {
        return parseFloat(this.amount || '0');
      }
      return parseFloat(this.amount - (this.riskedAmount || '0') || '0');
    },
    exceedsLimits() {
      if (this.isCustomLimitControl) {
        return this.limitControl;
      }
      return (this.min && this.amountToFloat() < this.min) || this.amountToFloat() > this.max;
    },
    isAmountEmpty() {
      if (!this.validity && (this.amount === '' || this.amount === '0' || this.amount === '0.00')) {
        return true;
      }
      return false;
    },
    normalizeAmount() {
      if (this.amount === '0' || this.amount === '0.00' || this.amount === 'NaN') {
        return '';
      }

      if (this.activeFreeBet && this.type === 'WIN') {
        let theProfit = !this.amount ? this.amount : roundAmount(this.amount - this.riskedAmount);
        return this.editAble || !this.amount ? this.amount : this.currency + '' + theProfit;
      }
        let riskedAmount = this.editAble || !this.amount ? this.amount : this.currency + '' +  roundAmount(this.amount);
   
      return riskedAmount
    },
  },
};
</script>

<style lang="scss" scoped>
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.is-invalid {
  background-image: none;
}

.bet-slip-form-control {
  &:nth-child(2) {
    margin-right: 0 !important;
  }
}

input,
input::-webkit-input-placeholder {
  font-size: 12px !important;
}
</style>
